export default [
   {
    title: 'Inventory',
    customIcon: 'InventorySvg',
    children: [
      {
        title: 'Privilege',
        route: 'custom-inventory-privilege-list',
        path: '/custom-inventory/privilege/list',
      },
    ],
  },
];